let typers = document.querySelectorAll('.jsTypingText');
typers.forEach((typer) => {
	let currentIndex = 0;
	let fullText = '';
	let charIndex = 0;
	let texts = JSON.parse(typer.dataset.texts);
	let typingSpeed = parseInt(typer.dataset.typingSpeed) || 150;
	let pauseBetweenTexts = parseInt(typer.dataset.pauseBetweenTexts) || 3000;

	function type() {
		if (charIndex < fullText.length) {
			typer.innerHTML += fullText.charAt(charIndex);
			charIndex++;
			setTimeout(type, typingSpeed);
		} else {
			setTimeout(() => {
				erase();
			}, pauseBetweenTexts);
		}
	}

	function erase() {
		if (charIndex > 0) {
			typer.innerHTML = fullText.substring(0, charIndex - 1);
			charIndex--;
			setTimeout(erase, typingSpeed);
		} else {
			currentIndex = (currentIndex + 1) % texts.length;
			fullText = texts[currentIndex];
			setTimeout(() => {
				type();
			}, typingSpeed);
		}
	}
	fullText = texts[currentIndex];
	type();
});